import _ from "lodash";
import { SelectOption } from "../../../global";

export const equipmentConditions: SelectOption[] = [
  { label: "New", value: "new" },
  { label: "Used", value: "used" },
  { label: "Demo", value: "demo" },
  { label: "Reconditioned", value: "reconditioned" },
];

export const equipmentAttachmentTypes: SelectOption[] = [
  { label: "Trailer", value: "Trailer" },
  { label: "Body", value: "Body" },
  { label: "Attachment", value: "Attachment" },
];

export const equipmentYears = _.range(1990, new Date().getFullYear() + 3).map(value => ({ label: `${value}`, value }));
